export const FETCH_MASTER_DATA = "FETCH_MASTER_DATA";
export const SET_MASTER_DATA = "SET_MASTER_DATA";
export const UPDATE_MASTER_DATA = "UPDATE_MASTER_DATA";
export const SET_APPLICATION_STATUS_MASTER = "SET_APPLICATION_STATUS_MASTER";
